import { forwardRef, useContext, useImperativeHandle } from "react"
import TemplateContext from "./TemplateContext"
import { findTemplateItem, viewItemForDraggableCatalogItem } from "./templateModel"
import CatalogBrowserContext, { ItemHandlerRef } from "../ItemCatalog/CatalogBrowserContext"

const ItemHandler = forwardRef((_, ref) => {
  const { dispatch, state, serverTemplate } = useContext(TemplateContext)

  useImperativeHandle(ref, () => ({
    addCatalogItem: (catalogItem, toId) => {
      const sortIndex = serverTemplate.items.length + state.addedItems.length
      dispatch({ type: 'ITEM_ADDED', serverTemplate, catalogItem, toId: toId ? parseInt(toId) : undefined, sortIndex })
    },
    updateSorting: (fromId, toId) => {
      dispatch({ type: 'ITEM_SORTED', fromId: parseInt(fromId), toId: parseInt(toId), serverTemplate })
    },
    findOverlayItem: (id) => {
      return findTemplateItem(state, serverTemplate, parseInt(id))
    },
    getViewItemForDraggableCatalogItem: (catalogItem, dragId) => {
      return viewItemForDraggableCatalogItem(catalogItem, dragId)
    }
  } as ItemHandlerRef))

  return <></>
})

const CatalogItemHandler = () => {
  const {itemHandlerRef} = useContext(CatalogBrowserContext)
  return <ItemHandler ref={itemHandlerRef} />
}

export default CatalogItemHandler